module.exports = __webpack_public_path__ + "static/media/ui@2x.a13c3356.png";